import { createImmutableObjectClass } from 'immutable-less/ImmutableObject';
export default class RequestTypeRecord extends createImmutableObjectClass({
  key: '',
  once: false,
  REQUESTED: '',
  SUCCEEDED: '',
  FAILED: ''
}) {
  getKey() {
    return this.key;
  }
}